import { createRoot } from 'react-dom/client';
import App from './App';

const container = document.getElementById('root');
// ReactDOM.render threw the same way for a missing container.
if (!container) throw new Error('Target container is not a DOM element.');

createRoot(container).render(<App />);
